export const getFocusedContentOrder = (state) => {
  return state.pages.projectView.modalData.focusedContentOrder.contentOrder;
};
